import './rte.scss';

class RTE {
    constructor ($element, options) {
        const settings = {
            speed: 500,
            onlyOneActive: true,
            waitUntilClose: false,
            activeClass: 'is--active',
            deactiveClass: null,
            breakPointMin: null
        };

        this.$rte = $element;
        this.settings = Object.assign({}, settings, options);
    }

    initialize () {
        const $$tables = this.$rte.querySelectorAll('table');
        if ($$tables.length > 0) {
            console.log('load scrolltable');
            import(
                /* webpackChunkName: "scrolltable/scrolltable.js" */
                './../scrolltable/scrolltable').then(({ Scrolltable }) => {
                for (let i = 0; i < $$tables.length; i++) {
                    const scrolltable = new Scrolltable($$tables[i]); // eslint-disable-line
                }
            });
        }
    }
}

export { RTE };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$rte = $context.querySelectorAll('[data-rte="root"]');

    for (let i = 0; i < $$rte.length; i++) {
        const rte = new RTE($$rte[i]);
        rte.initialize();
    }
});
